<template>
  <div class="dimension-in-condition-editor">
    <div v-if="dimensionInvalid">
      Please select a valid dimension!
    </div>
    <div class="select-actions">
      <b-button
        type="is-text"
        size="is-small"
        :disabled="dimensionInvalid"
        @click="selectAll">
        Select All
      </b-button>
      <b-button
        type="is-text"
        size="is-small"
        :disabled="dimensionInvalid"
        @click="clearAll">
        Clear All
      </b-button>
    </div>
    <div class="ref-select">
      <MultiSelect
        v-model="keyValues"
        :loading="loadingValues"
        :disabled="dimensionInvalid"
        :options="dimensionValues || []"
        label="value"
        track-by="key"
        class="input-item" />
    </div>
    <ValidationErrors :errors="keyValuesErrors" />
  </div>
</template>

<script>

  import ObjectEditorMixin from '@/components/reports/config/common/ObjectEditorMixin'
  import MultiSelect from '@/components/ui/multiselect'
  import { childErrors } from '@/components/reports/config/common/validation'

  export default {
    name: 'DimensionInConditionEditor',
    components: {
      MultiSelect,
    },
    mixins: [
      ObjectEditorMixin,
    ],
    props: {
      context: {
        type: Object,
        default: Object,
      },
    },
    computed: {
      dimensionValues () {
        return this.context.dimensionValues || []
      },
      dimensionValuesByKey () {
        const map = {}
        this.dimensionValues.forEach(dv => {
          map[dv.key] = dv
        })
        return map
      },
      loadingValues () {
        return this.context.loadingValues || false
      },
      keyValues: {
        get () {
          return (this.vModel.key_values.map(
            k => this.dimensionValuesByKey[k]
          ) || [])
        },
        set (keyValues) {
          this.vModel = {
            ...this.vModel,
            key_values: keyValues.map(v => v.key),
          }
        },
      },
      keyValuesErrors () {
        return childErrors('key_values', this.errors)
      },
      dimensionInvalid () {
        return !this.dimensionValues && !this.loading
      },
    },
    methods: {
      selectAll () {
        this.keyValues = [...this.dimensionValues,]
      },
      clearAll () {
        this.keyValues = []
      },
    },
  }

</script>

<style lang="scss" scoped>
.dimension-in-condition-editor {
  display: flex;
  flex-direction: column;
}

.select-actions {
  display: flex;
  gap: 4px;
  margin-bottom: 4px;
}
</style>
